import api from 'lib/api';

export const GET_SCHOOL_TYPES = 'GET_SCHOOL_TYPES';
export const GET_TENANT_CONSENT = 'CHECK_TENANT_CONSENT';

export const getSchoolTypes = () => ({
	type: GET_SCHOOL_TYPES,
	payload: new Promise((resolve) => {
		api.get(`tenants/schooltypes`).then((response) => {
			resolve(response.data);
		});
	}),
});

export const getTenantConsent = () => ({
	type: GET_TENANT_CONSENT,
	payload: new Promise((resolve) => {
		api.get(`tenants/consented`).then((response) => {
			resolve(response.data);
		});
	}),
});